module.exports = __webpack_public_path__ + "static/media/proposal-invoice-icon.3aef72d1.svg";